<section class="row flex flex-wrap box-border">
    <div class="flex">
      <div class="m-auto">
        <div class="success-icon mx-auto my-5"></div>
        <div class="flex flex-col px-8 py-6 rounded-gt-md-3 w-185 h-auto msg-container">
            <div class="text-7gpx text-text-default-1 mb-2 font-body">
              All done! Have a good time <span class="font-emoji text-9gpx" [innerHTML]="emoji"></span>
            </div>
            <button class="text-primary font-semibold text-7gpx flex font-body-semibold cursor-pointer" (click)="returnTologin()">
              Go back to log in
          </button>
        </div>
      </div>
    </div>
</section>
